const gradients = {
  lightGrey: 'linear-gradient(180deg, rgba(238, 238, 238, 0) 0%, #d8d8d8 100%);',
};

export default gradients;

export type ThemeGradients = typeof gradients;
export type ThemeGradientsKeys = keyof typeof gradients;
